<template>

  <div>

    <b-card 
      title="Detalle de estiba">

      <b-row>
        <b-col cols="12">

          <validate-repeated-card :stowage-id="stowageId"/>

        </b-col>
      </b-row>

    </b-card>

  </div>

</template>

<script>
import router from '@/router'
import { BRow, BCol, BTabs, BTab, BCard } from 'bootstrap-vue'
import ValidateRepeatedCard from './ValidateRepeatedCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,

    ValidateRepeatedCard,
  },
  data() {
    return {
      stowageId: null,
    }
  },
  created() {
    this.stowageId = router.currentRoute.params.stowage_id
    console.log(this.stowageId)
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>